"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = formatter;
function addIntegerSeparators(x, separator) {
    x += '';
    if (!separator) {
        return x;
    }
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x)) {
        x = x.replace(rgx, '$1' + separator + '$2');
    }
    return x;
}
function addDecimalSeparators(x, separator) {
    x += '';
    if (!separator) {
        return x;
    }
    const rgx = /(\d{3})(\d+)/;
    while (rgx.test(x)) {
        x = x.replace(rgx, '$1' + separator + '$2');
    }
    return x;
}
function padLeft(x, padding) {
    x = x + '';
    const buf = [];
    while (buf.length + x.length < padding) {
        buf.push('0');
    }
    return buf.join('') + x;
}
function padRight(x, padding) {
    if (x) {
        x += '';
    }
    else {
        x = '';
    }
    const buf = [];
    while (buf.length + x.length < padding) {
        buf.push('0');
    }
    return x + buf.join('');
}
function truncate(x, length) {
    if (x) {
        x += '';
    }
    if (x && x.length > length) {
        return x.substr(0, length);
    }
    else {
        return x;
    }
}
function round(numberParts, places) {
    if (numberParts[1] && places >= 0 && numberParts[1].length > places) {
        let decim = numberParts[1].slice(0, places);
        if (+(numberParts[1].substr(places, 1)) >= 5) {
            let leadingzeros = '';
            while (decim.charAt(0) === '0') {
                leadingzeros = leadingzeros + '0';
                decim = decim.substr(1);
            }
            decim = (+decim + 1) + '';
            decim = leadingzeros + decim;
            if (decim.length > places) {
                numberParts[0] = (+numberParts[0] + +decim.charAt(0)) + '';
                decim = decim.substring(1);
            }
        }
        numberParts[1] = decim;
    }
    return numberParts;
}
function formatter(options) {
    options = options || {};
    options.negativeType = options.negativeType || 'left';
    if (typeof options.negativeLeftSymbol !== 'string') {
        switch (options.negativeType) {
            case 'left':
                options.negativeLeftSymbol = '-';
                break;
            case 'brackets':
                options.negativeLeftSymbol = '(';
                break;
            default:
                options.negativeLeftSymbol = '';
        }
    }
    if (typeof options.negativeRightSymbol !== 'string') {
        switch (options.negativeType) {
            case 'right':
                options.negativeRightSymbol = '-';
                break;
            case 'brackets':
                options.negativeRightSymbol = ')';
                break;
            default:
                options.negativeRightSymbol = '';
        }
    }
    if (typeof options.negativeLeftOut !== 'boolean') {
        options.negativeLeftOut = true;
    }
    if (typeof options.negativeRightOut !== 'boolean') {
        options.negativeRightOut = true;
    }
    options.prefix = options.prefix || '';
    options.suffix = options.suffix || '';
    if (typeof options.integerSeparator !== 'string') {
        options.integerSeparator = ',';
    }
    options.decimalsSeparator = typeof options.decimalsSeparator === 'string' ? options.decimalsSeparator : '';
    options.decimal = options.decimal || '.';
    options.padLeft = options.padLeft || -1;
    options.padRight = options.padRight || -1;
    if (typeof options.prefix !== 'string') {
        options.prefix = '';
    }
    const format = (number, overrideOptions) => {
        overrideOptions = overrideOptions || {};
        if (number || number === 0) {
            number = '' + number;
        }
        else {
            return '';
        }
        const output = [];
        const negative = number.charAt(0) === '-';
        number = number.replace(/^-/g, '');
        if (!options.negativeLeftOut && !overrideOptions.noUnits) {
            output.push(options.prefix);
        }
        if (negative) {
            output.push(options.negativeLeftSymbol);
        }
        if (options.negativeLeftOut && !overrideOptions.noUnits) {
            output.push(options.prefix);
        }
        const numberParts = number.split('.');
        if (options.round != null) {
            round(numberParts, options.round);
        }
        if (options.truncate != null) {
            numberParts[1] = truncate(numberParts[1], options.truncate);
        }
        if (options.padLeft && options.padLeft > 0) {
            numberParts[0] = padLeft(numberParts[0], options.padLeft);
        }
        if (options.padRight && options.padRight > 0) {
            numberParts[1] = padRight(numberParts[1], options.padRight);
        }
        if (!overrideOptions.noSeparator && numberParts[1]) {
            numberParts[1] = addDecimalSeparators(numberParts[1], options.decimalsSeparator);
        }
        if (!overrideOptions.noSeparator && numberParts[0]) {
            numberParts[0] = addIntegerSeparators(numberParts[0], options.integerSeparator);
        }
        output.push(numberParts[0]);
        if (numberParts[1]) {
            output.push(options.decimal);
            output.push(numberParts[1]);
        }
        if (options.negativeRightOut && !overrideOptions.noUnits) {
            output.push(options.suffix);
        }
        if (negative) {
            output.push(options.negativeRightSymbol);
        }
        if (!options.negativeRightOut && !overrideOptions.noUnits) {
            output.push(options.suffix);
        }
        return output.join('');
    };
    format.negativeType = options.negativeType;
    format.negativeLeftOut = options.negativeLeftOut;
    format.negativeLeftSymbol = options.negativeLeftSymbol;
    format.negativeRightOut = options.negativeRightOut;
    format.negativeRightSymbol = options.negativeRightSymbol;
    format.prefix = options.prefix;
    format.suffix = options.suffix;
    format.integerSeparator = options.integerSeparator;
    format.decimalsSeparator = options.decimalsSeparator;
    format.decimal = options.decimal;
    format.padLeft = options.padLeft;
    format.padRight = options.padRight;
    format.truncate = options.truncate;
    format.round = options.round;
    function unformat(number, allowedSeparators) {
        allowedSeparators = allowedSeparators || [];
        if (options.allowedSeparators) {
            options.allowedSeparators.forEach((s) => (allowedSeparators).push(s));
        }
        allowedSeparators.push(options.integerSeparator);
        allowedSeparators.push(options.decimalsSeparator);
        number = number.replace(options.prefix, '');
        number = number.replace(options.suffix, '');
        let newNumber = number;
        do {
            number = newNumber;
            for (const value of allowedSeparators) {
                newNumber = newNumber.replace(value, '');
            }
        } while (newNumber !== number);
        return number;
    }
    format.unformat = unformat;
    return format;
}
//# sourceMappingURL=format-number.js.map